import { useEffect } from 'react';
import { InteractionStatus } from '@azure/msal-browser';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { getBackofficeLoginRequest } from './config';
import { getCurrentReturnPath, setReturnPath } from './session';

export function RequireBackofficeAuth({ children }: { children: React.ReactNode }) {
  const { instance, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    if (isAuthenticated || inProgress !== InteractionStatus.None) {
      return;
    }

    setReturnPath(getCurrentReturnPath());
    void instance.loginRedirect(getBackofficeLoginRequest());
  }, [inProgress, instance, isAuthenticated]);

  if (!isAuthenticated) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-white text-small text-neutral-600">
        Signing in...
      </div>
    );
  }

  return <>{children}</>;
}
